import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesArrayMin } from './ITypeValidatesArrayMin';

export class ArrayMinValidator
  implements ValidatorInterface<ITypeValidatesArrayMin>
{
  name = 'ArrayMin';

  friendlyName = 'List Minimum Size';

  arrayOnly = true;

  array = true;

  description = 'Minimum number of entries for this list.';

  types = null;

  properties = {
    value: {
      type: 'Number',
      default: 1,
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'Min',
          value: 0,
        },
        {
          name: 'Max',
          value: Number.MAX_SAFE_INTEGER,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesArrayMin) {
    type.addArrayMinValidator(this);
  }
}

const arrayMinValidator = new ArrayMinValidator(undefined);

ValidatorRegistry.register(ArrayMinValidator, arrayMinValidator.name);

export { arrayMinValidator };
